export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CaregiverRoleEnum_AllergyDoctor": "The doctor",
	"CaregiverRoleEnum_Dentist": "The dentist",
	"CaregiverRoleEnum_Dermatologist": "The dermatologist",
	"CaregiverRoleEnum_Doctor": "The family doctor",
	"CaregiverRoleEnum_Midwife": "The midwife",
	"CaregiverRoleEnum_Nurse": "The nurse",
	"CaregiverRoleEnum_Physiotherapist": "The physiotherapist",
	"CaregiverRoleEnum_Psychologist": "The psychologist",
	"CaregiverRoleEnum_Rheumatologist": "The rheumatologist",
	"CaregiverRoleEnum_SundVaegtDoctor": "The SundVægt doctor",
	"CaregiverRoleEnum_SundVaegtNurse": "The SundVægt nurse",
	"CaregiverRoleEnum_Dietitian": "The dietitian",
	"CaregiverRoleEnum_AcneDermatologist": "The dermatologist",
	"CaregiverRoleEnum_Veterinarian": "The veterinarian",
	"CaregiverRoleEnum_AllergyDoctor_Indefinite": "Doctor",
	"CaregiverRoleEnum_Dentist_Indefinite": "Dentist",
	"CaregiverRoleEnum_Dermatologist_Indefinite": "Dermatologist",
	"CaregiverRoleEnum_Doctor_Indefinite": "Family doctor",
	"CaregiverRoleEnum_Midwife_Indefinite": "Midwife",
	"CaregiverRoleEnum_Nurse_Indefinite": "Nurse",
	"CaregiverRoleEnum_Physiotherapist_Indefinite": "Physiotherapist",
	"CaregiverRoleEnum_Psychologist_Indefinite": "Psychologist",
	"CaregiverRoleEnum_Rheumatologist_Indefinite": "Rheumatologist",
	"CaregiverRoleEnum_SundVaegtDoctor_Indefinite": "SundVægt doctor",
	"CaregiverRoleEnum_SundVaegtNurse_Indefinite": "SundVægt nurse",
	"CaregiverRoleEnum_Dietitian_Indefinite": "Dietitian",
	"CaregiverRoleEnum_AcneDermatologist_Indefinite": "Dermatologist",
	"CaregiverRoleEnum_Veterinarian_Indefinite": "Veterinarian",
	"CaregiverSpecialization_ClinicalPsychologist": "Clinical psychologist",
	"CaregiverSpecialization_FamilyTherapy": "Family therapy",
	"CaregiverSpecialization_SundVaegt": "SundVægt",
	"CaregiverSpecialization_Pediatric": "Pediatrics",
	"ConsultationPaymentProviderEnum_ApplePay": "App Store",
	"ConsultationPaymentProviderEnum_Company": "Company",
	"ConsultationPaymentProviderEnum_Coupon": "Coupon",
	"ConsultationPaymentProviderEnum_DIBS": "Pay per use",
	"ConsultationPaymentProviderEnum_ePay": "Pay per use",
	"ConsultationPaymentProviderEnum_GoogleWallet": "Google Play",
	"ConsultationPaymentProviderEnum_GracePeriod": "Grace period",
	"ConsultationPaymentProviderEnum_ReepayCheckout": "Pay per use",
	"ConsultationPaymentProviderEnum_Repay": "Pay per use",
	"ConsultationPaymentProviderEnum_Subscription": "Subscription",
	"ConsultationPaymentProviderEnum_PriceOverride": "-",
	"ConsultationCategoryFilterEnum_Video": "Video",
	"ConsultationCategoryFilterEnum_Text": "Text",
	"ConsultationTypeEnum_AllergyCheckVideo": "Allergy check",
	"ConsultationTypeEnum_DentistMessage": "Dentist email",
	"ConsultationTypeEnum_DentistVideo": "Dentist video",
	"ConsultationTypeEnum_DermatologistMessage": "Dermatologist message",
	"ConsultationTypeEnum_DermatologistVideo": "Dermatologist video",
	"ConsultationTypeEnum_Message": "Family doctor message",
	"ConsultationTypeEnum_MidwifeMessage": "Midwife message",
	"ConsultationTypeEnum_MidwifeVideo": "Midwife video",
	"ConsultationTypeEnum_NurseMessage": "Nurse message",
	"ConsultationTypeEnum_NurseVideo": "Nurse video",
	"ConsultationTypeEnum_PhysiotherapistStartupVideo": "Physiotherapist startup video",
	"ConsultationTypeEnum_PhysiotherapistMessage": "Physiotherapist: Text consultation",
	"ConsultationTypeEnum_Prescription": "Prescription renewal",
	"ConsultationTypeEnum_PsychologistVideo": "Psychologist video",
	"ConsultationTypeEnum_PsychologistCrisisVideo": "Crisis counseling",
	"ConsultationTypeEnum_PsychologistFamilyTherapyVideo": "Family therapy",
	"ConsultationTypeEnum_RheumatologistVideo": "Rheumatologist video",
	"ConsultationTypeEnum_SundVaegtStartupMessage": "SundVægt startup",
	"ConsultationTypeEnum_SundVaegtNurseCheckupVideo": "SundVægt checkup",
	"ConsultationTypeEnum_Video": "Family doctor video",
	"ConsultationTypeEnum_DietitianStartupVideo": "Video consultation - dietitian startup",
	"PlanInterval_Day": "Daily",
	"PlanInterval_Month": "Monthly",
	"PlanInterval_Week": "Weekly",
	"PlanInterval_Year": "Annual",
	"ServiceTypeEnum_AllergyCheck": "Allergy check: Video consultation",
	"ServiceTypeEnum_DermatologistMessage": "Dermatologist: Text consultation",
	"ServiceTypeEnum_DermatologistMessageReply": "Dermatologist: Reply to text consultation",
	"ServiceTypeEnum_DermatologistVideo": "Dermatologist: Video consultation",
	"ServiceTypeEnum_Message": "Doctor: Text consultation",
	"ServiceTypeEnum_MessageReply": "Doctor: Reply to text consultation",
	"ServiceTypeEnum_PhysiotherapistStartupVideo": "Physiotherapist: Startup video consultation",
	"ServiceTypeEnum_PhysiotherapistMessage": "Physiotherapist: Text consultation",
	"ServiceTypeEnum_PhysiotherapistMessageReply": "Physiotherapist: Reply to text consultation",
	"ServiceTypeEnum_Prescription": "Doctor: Prescription renewal",
	"ServiceTypeEnum_PsychologistVideo": "Psychologist: Video consultation",
	"ServiceTypeEnum_PsychologistCrisisVideo": "Crisis counseling: Video consultation",
	"ServiceTypeEnum_PsychologistFamilyTherapyVideo": "Family therapist: Video consultation",
	"ServiceTypeEnum_RheumatologistVideo": "Rheumatologist: Video consultation",
	"ServiceTypeEnum_SundVaegtStartupMessage": "SundVægt startup",
	"ServiceTypeEnum_VideoConsultation": "Doctor: Video consultation",
	"ServiceTypeEnum_AllergyCheckVideo": "Allergy check",
	"ServiceTypeEnum_DietitianStartupVideo": "Dietitan: Startup video consultation",
	"UserTypeEnum_Admin": "Admin",
	"UserTypeEnum_Doctor": "Caregiver",
	"UserTypeEnum_Patient": "Patient",
	"ConsultationTypeEnum_SundVaegtDoctorCheckupVideo": "SundVægt doctor: Video consultation",
	"ServiceTypeEnum_SundVaegtDoctorCheckupVideo": "SundVægt doctor: Video consultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupVideo": "SundVægt: Checkup video consultation",
	"ConsultationTypeEnum_SundVaegtNurseCheckupMessage": "SundVægt: Text consultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessage": "SundVægt: Text consultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessageReply": "SundVægt: Reply to text consultation",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessageReply": "SundVægt: Questionnaire reply",
	"ConsultationTypeEnum_SundVaegtNurseAdHocVideo": "SundVægt checkup",
	"ServiceTypeEnum_SundVaegtNurseAdHocVideo": "SundVægt: Ad hoc video",
	"ConsultationTypeEnum_SundVaegtQuestionnaireMessage": "SundVægt: Questionnaire",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessage": "SundVægt: Questionnaire",
	"ConsultationTypeEnum_PhysiotherapistCheckupVideo": "Physiotherapist checkup video",
	"ServiceTypeEnum_PhysiotherapistCheckupVideo": "Physiotherapist: Checkup video consultation",
	"ConsultationTypeEnum_PhysiotherapistQuestionnaireMessage": "Physiotherapist questionnaire",
	"ServiceTypeEnum_PhysiotherapistQuestionnaireMessage": "Physiotherapist: questionnaire",
	"ServiceTypeEnum_SundVaegtStartupMessageReply": "SundVægt: Startup reply",
	"SubscriptionStatusEnum_Active": "Active",
	"SubscriptionStatusEnum_Canceled": "Canceled",
	"SubscriptionStatusEnum_Expired": "Expired",
	"SubscriptionStatusEnum_PastDue": "Past due",
	"SubscriptionStatusEnum_Trialing": "Free trial",
	"SubscriptionStatusEnum_Unknown": "Unknown",
	"ConsultationTypeEnum_DietitianCheckupVideo": "Dietitian: Video follow up",
	"ServiceTypeEnum_DietitianCheckupVideo": "Dietitian: Video follow up",
	"ConsultationTypeEnum_DietitianUploadAttachmentMessage": "Send files to the dietitian",
	"ServiceTypeEnum_DietitianUploadAttachmentMessage": "Dietitian: Upload attachments",
	"ServiceTypeEnum_DietitianVideo": "Dietitian: Video consultation",
	"AllergyCheckVideo": "Allergy check video",
	"ConsultationTypeEnum_AllergyCheck": "Allergy check",
	"ConsultationTypeEnum_PersonalHealthProgrammeStartup": "Personal health programme startup",
	"ServiceTypeEnum_PersonalHealthProgrammeStartup": "Personal health programme startup",
	"ConsultationTypeEnum_AcneProgrammeStartupMessage": "Acne programme startup",
	"ConsultationTypeEnum_AcneProgrammeStartupVideo": "Acne programme video startup",
	"ConsultationTypeEnum_AcneProgrammeCheckupVideo": "Acne programme video checkup",
	"ServiceTypeEnum_AcneProgrammeStartupMessage": "Acne programme startup",
	"ServiceTypeEnum_AcneProgrammeStartupVideo": "Acne programme video startup",
	"ServiceTypeEnum_AcneProgrammeCheckupVideo": "Acne programme video checkup",
	"ConsultationTypeEnum_AcneDermatologistMessage": "Dermatologist message",
	"ServiceTypeEnum_AcneDermatologistMessage": "Dermatologist: Text consultation",
	"ServiceTypeEnum_AcneDermatologistMessageReply": "Dermatologist: Reply to text consultation",
	"ServiceTypeEnum_VeterinarianVideo": "Veterinarian: Video consultation",
	"ConsultationPaymentProviderEnum_Free": "Free of charge",
	"ConsultationPaymentProviderEnum_CreatedByCaregiver": "Created by caregiver",
	"ConsultationTypeEnum_VeterinarianVideo": "Video consultation - veterinarian",
	"PetSex_Female": "Female",
	"PetSex_FemaleSterilized": "Female sterilized",
	"PetSex_Male": "Male",
	"PetSex_MaleNeutered": "Male neutered",
	"PetSex_Unknown": "Unknown",
	"PetType_Dog": "Dog",
	"PetType_Cat": "Cat",
	"PetType_Rabbit": "Rabbit",
	"PetType_Rodent": "Rodent",
	"ReferralOptionEnum_SpecialistsAndPrivateHospitals": "Specialists and private hospitals",
	"ReferralOptionEnum_Physiotherapy": "Physiotherapy",
	"ReferralOptionEnum_Psychologist": "Psychologist",
	"VetConsultationReasonEnum_Gastrointestinal": "Gastrointestinal",
	"VetConsultationReasonEnum_SkinCoatEars": "Skin, coat and ears (incl. wounds and anal glands)",
	"VetConsultationReasonEnum_Poisoning": "Poisoning",
	"VetConsultationReasonEnum_Eyes": "Eyes",
	"VetConsultationReasonEnum_UrinaryTract": "Urinary tract",
	"VetConsultationReasonEnum_Lameness": "Lameness",
	"VetConsultationReasonEnum_RespiratoryTract": "Respiratory tract",
	"VetConsultationReasonEnum_OralCavity": "Oral cavity and teeth",
	"VetConsultationReasonEnum_Pain": "Pain/fever/lethargy",
	"VetConsultationReasonEnum_Claws": "Claws",
	"VetConsultationReasonEnum_GenitalsMammaryGlands": "Genitals and mammary glands",
	"VetConsultationReasonEnum_ReproductionCycle": "Reproduction and cycle",
	"VetConsultationReasonEnum_Behaviour": "Behaviour",
	"VetConsultationReasonEnum_Prescription": "Prescription",
	"VetConsultationReasonEnum_OtherReason": "Other",
	"VetConsultationOutcomeEnum_AdvisedForHomeTreatment": "Advised for home treatment (including cases not requiring treatment)",
	"VetConsultationOutcomeEnum_ReferredDuringRegularOpeningHours": "Referred during regular opening hours",
	"VetConsultationOutcomeEnum_ReferredOutsideRegularOpeningHours": "Referred outside regular opening hours",
	"PhysioConsultationOutcomeEnum_ConservativeApproachPatientContinuesAlone": "Conservative approach, patient continues on their own",
	"PhysioConsultationOutcomeEnum_OfferedFollowUpConsultation": "Offered follow-up consultation (conservative approach)",
	"PhysioConsultationOutcomeEnum_ReturnedToVisitationForPhysicalTreatment": "Returned to visitation for physical treatment",
	"PhysioConsultationOutcomeEnum_ReturnedToOwnDoctor": "Returned to own doctor",
	"PhysioConsultationOutcomeEnum_NoShow": "No-show",
	"ConsultationTypeEnum_DynamicCodeVideo": "Video consultation - Dynamic Code",
	"ServiceTypeEnum_DynamicCodeVideo": "Video consultation - Dynamic Code",
	"ServiceTypeEnum_NurseVideo": "Nurse: video",
	"ServiceTypeEnum_MidwifeVideo": "Midwife: video",
	"ServiceTypeEnum_NurseMessage": "Nurse: Text consultation",
	"ServiceTypeEnum_NurseMessageReply": "Nurse: Reply to text consultation",
	"ServiceTypeEnum_MidwifeMessage": "Midwife: Text consultation",
	"ServiceTypeEnum_MidwifeMessageReply": "Midwife: Reply to text consultation",
	"ConsultationTypeEnum_VeterinarianMessage": "Veterinarian message",
	"ServiceTypeEnum_VeterinarianMessage": "Veterinarian: Text consultation",
	"ServiceTypeEnum_VeterinarianMessageReply": "Veterinarian: Reply to text consultation",
	"VetConsultationOutcomeEnum_RequestedMoreInformation": "Requested more information (or book another video consultation)",
	"ConsultationTypeEnum_PracticeManagerMessage": "Other request",
	"CaregiverRoleEnum_PracticeManager_Indefinite": "Practice manager",
	"ServiceTypeEnum_PracticeManagerMessage": "Other request",
	"CaregiverRoleEnum_PracticeManager": "The practice manager",
	"ConsultationTypeEnum_PsychologistMessage": "Psychologist: Text consultation",
	"ServiceTypeEnum_PsychologistMessage": "Psychologist: Text consultation",
	"SubscriptionStatusEnum_OnHold": "On hold",
	"ReferralType_Physiotherapy": "Physiotherapy referral",
	"ReferralType_Hospital": "Hospital referral",
	"ReferralType_Psychologist": "Psychologist referral",
	"ReferralType_Specialist": "Specialist referral",
	"SpecialistVisitationOptionsEnum_InternMedicine": "Intern Medicine",
	"SpecialistReferralCode_TreatmentAndInvestigation": "Investigation and treatment",
	"SpecialistReferralCode_Radiology": "Radiology",
	"SpecialistReferralCode_ContinuedTreatment": "Continued treatment",
	"SpecialistReferralCode_Visit": "Visit",
	"SpecialistReferralCode_SingleConsultationAssessment": "Assessment at a single consultation",
	"HospitalCallPriority_Urgent": "urgent",
	"HospitalCallPriority_Elective": "elective",
	"HospitalStatus_Outpatient": "outpatient",
	"HospitalStatus_Admission": "admission",
	"HospitalTransport_None": "none",
	"HospitalTransport_Seated": "seated",
	"HospitalTransport_Lying": "lying",
	"PsychologyDiagnosis_RobberyViolenceOrRapeVictim": "Robbery-, violence or rape victim",
	"PsychologyDiagnosis_TrafficOrAccidentVictim": "Traffic or accident victim",
	"PsychologyDiagnosis_RelativesOfSeriouslyMentallyIllPersons": "Relatives of seriously mentally ill persons",
	"PsychologyDiagnosis_PersonsAffectedBySeriousDisablingDisease": "Persons affected by serious disabling disease",
	"PsychologyDiagnosis_RelativesOfPersonsAffectedBySeriousDisablingDisease": "Relatives of persons affected by serious disabling disease",
	"PsychologyDiagnosis_RelativesInCaseOfDeath": "Relatives in case of death",
	"PsychologyDiagnosis_PersonsWhoHaveAttemptedSuicide": "Persons who have attempted suicide",
	"PsychologyDiagnosis_WomenUndergoingAbortionAfter12WeeksOfPregnancy": "Women undergoing abortion after 12 weeks of pregnancy",
	"PsychologyDiagnosis_PersonsUnder18WhoHaveBeenVictimsOfIncestOrOtherSexualAbuse": "Persons under 18 who have been victims of incest or other sexual abuse",
	"PsychologyDiagnosis_PersonsWithMildToModerateDepressionAfterPsychometricTest": "Persons with mild to moderate depression after psychometric test",
	"PsychologyDiagnosis_PersonsWithMildToModerateAnxietyIncludingMildToModerateOCD": "Persons with mild to moderate anxiety including mild to moderate OCD",
	"PsychologyDiagnosis_DeviationFrom6Months": "Deviation from 6 months",
	"ServiceTypeEnum_NnStartupVideo": "SundVægtSammen: Startup video",
	"ServiceTypeEnum_NnNurseCheckupVideo": "SundVægtSammen: Follow-up video with SundVægt nurse",
	"ServiceTypeEnum_NnDietitianCheckupVideo": "SundVægtSammen: Follow-up video with dietitian",
	"ServiceTypeEnum_NnDoctorMessage": "SundVægtSammen: Message to SundVægt doctor",
	"ServiceTypeEnum_NnDoctorMessageReply": "SundVægtSammen: Reply from SundVægt doctor",
	"ServiceTypeEnum_NnScreeningQuestionnaireMessage": "SundVægtSammen: Screening questionnaire",
	"ServiceTypeEnum_NnOnboardingQuestionnaireMessage": "SundVægtSammen: Onboarding questionnaire",
	"ServiceTypeEnum_NnCheckupQuestionnaireMessage": "SundVægtSammen: Follow-up questionnaire",
	"ServiceTypeEnum_NnExitQuestionnaireMessage": "SundVægtSammen: Final questionnaire",
	"ServiceTypeEnum_SundVaegtExitQuestionnaireMessage": "SundVægt: Exit questionnaire",
	"ConsultationTypeEnum_NnStartupVideo": "SundVægtSammen startup video",
	"ConsultationTypeEnum_NnNurseCheckupVideo": "SundVægtSammen follow-up video with nurse",
	"ConsultationTypeEnum_NnDietitianCheckupVideo": "SundVægtSammen follow-up video with dietitian",
	"ConsultationTypeEnum_NnDoctorMessage": "SundVægtSammen message to doctor",
	"ConsultationTypeEnum_NnScreeningQuestionnaireMessage": "SundVægtSammen screening questionnaire",
	"ConsultationTypeEnum_NnOnboardingQuestionnaireMessage": "SundVægtSammen onboarding questionnaire",
	"ConsultationTypeEnum_NnCheckupQuestionnaireMessage": "SundVægtSammen follow-up questionnaire",
	"ConsultationTypeEnum_NnExitQuestionnaireMessage": "SundVægtSammen final questionnaire",
	"ConsultationTypeEnum_SundVaegtExitQuestionnaireMessage": "SundVægt exit questionnaire",
	"ConsultationTypeEnum_SundVaegtFeedbackQuestionnaireMessage": "SundVægt feedback questionnaire",
	"ServiceTypeEnum_SundVaegtFeedbackQuestionnaireMessage": "SundVægt: feedback questionnaire",
	"HospitalPriorityOptionsEnum_Urgent": "Urgent",
	"HospitalPriorityOptionsEnum_Elective": "Elective",
	"HospitalTransportOptionsEnum_None": "None",
	"HospitalTransportOptionsEnum_Seated": "Seated",
	"HospitalTransportOptionsEnum_Lying": "Lying",
	"HospitalStatusOptionsEnum_Admission": "Admission",
	"HospitalStatusOptionsEnum_Outpatient": "Outpatient",
	"ConsultationPaymentProviderEnum_HouseholdAccess": "Household access",
	"ServiceTypeEnum_MenopauseStartupVideo": "SundOvergang: startup consultation with doctor",
	"ServiceTypeEnum_MenopauseNurseCheckupVideo": "SundOvergang: follow-up video with nurse",
	"ServiceTypeEnum_MenopauseNurseMessage": "SundOvergang: message to nurse",
	"ServiceTypeEnum_MenopauseNurseMessageReply": "SundOvergang: reply from nurse",
	"ConsultationTypeEnum_MenopauseStartupVideo": "SundOvergang: startup consultation with doctor",
	"ConsultationTypeEnum_MenopauseNurseCheckupVideo": "SundOvergang: follow-up video with nurse",
	"ConsultationTypeEnum_MenopauseNurseMessage": "SundOvergang: text consultation",
	"ConsultationTypeEnum_MenopauseOffboardingVideo": "SundOvergang: final consultation with doctor",
	"ServiceTypeEnum_MenopauseOffboardingVideo": "SundOvergang: final consultation with doctor",
	"CaregiverRoleEnum_Gynecologist": "The gynecologist",
	"CaregiverRoleEnum_MenopauseDoctor": "The SundOvergang doctor",
	"CaregiverSpecialization_Menopause": "Menopause",
	"CaregiverRoleEnum_Gynecologist_Indefinite": "Gynecologist",
	"CaregiverRoleEnum_MenopauseDoctor_Indefinite": "SundOvergang doctor",
	"ConsultationTypeEnum_DietitianMessage": "Dietitian message",
	"ServiceTypeEnum_DietitianMessage": "Dietitian: Text consultation",
	"ServiceTypeEnum_DietitianMessageReply": "Dietitian: Reply to text consultation",
	"EpicrisisDocumentType_DischargeLetter": "Discharge Letter",
	"EpicrisisDocumentType_OutPatientDischargeLetter": "Out-Patient Discharge Letter",
	"EpicrisisDocumentType_CasualtyWardLetter": "Casualty Ward Letter",
	"EpicrisisDocumentType_RadiologyReport": "Radiology Report",
	"EpicrisisDocumentType_PrivateSpecialistLetter": "Private Specialist Letter",
	"ConsultationTypeEnum_MenopauseDietitianVideo": "SundOvergang: video consultation with dietitian",
	"ServiceTypeEnum_MenopauseDietitianVideo": "SundOvergang: video consultation with dietitian",
	"ServiceTypeEnum_MenopauseHalfwayVideo": "SundOvergang: halfway consultation with doctor",
	"ConsultationTypeEnum_MenopauseHalfwayVideo": "SundOvergang: halfway consultation with doctor",
	"AuditProblemCategory_IncorrectDiagnosis": "Incorrect diagnosis",
	"AuditProblemCategory_InsufficientTreatment": "Insufficient treatment",
	"AuditProblemCategory_MedicationError": "Medication error",
	"AuditProblemCategory_DocumentationError": "Documentation error",
	"AuditProblemCategory_CommunicationIssue": "Communication issue",
	"AuditProblemCategory_OtherIssue": "Other",
	"PhysioConsultationOutcomeEnum_OfferedVideoConsultation": "Offered video consultation",
	"PhysioConsultationOutcomeEnum_NeedMoreInformation": "Need more information",
	"CaregiverRoleEnum_Doctor_Plural": "Family doctors",
	"CaregiverRoleEnum_Nurse_Plural": "Nurses",
	"CaregiverRoleEnum_Dentist_Plural": "Dentists",
	"CaregiverRoleEnum_Midwife_Plural": "Midwives",
	"CaregiverRoleEnum_Dermatologist_Plural": "Dermatologists",
	"CaregiverRoleEnum_Rheumatologist_Plural": "Rheumatologists",
	"CaregiverRoleEnum_Physiotherapist_Plural": "Physiotherapists",
	"CaregiverRoleEnum_Psychologist_Plural": "Psychologists",
	"CaregiverRoleEnum_AllergyDoctor_Plural": "Doctors",
	"CaregiverRoleEnum_SundVaegtDoctor_Plural": "SundVægt doctors",
	"CaregiverRoleEnum_SundVaegtNurse_Plural": "SundVægt nurses",
	"CaregiverRoleEnum_Dietitian_Plural": "Dietitians",
	"CaregiverRoleEnum_AcneDermatologist_Plural": "Dermatologists",
	"CaregiverRoleEnum_Veterinarian_Plural": "Veterinarians",
	"CaregiverRoleEnum_PracticeManager_Plural": "Practice managers",
	"CaregiverRoleEnum_Gynecologist_Plural": "Gynecologists",
	"CaregiverRoleEnum_MenopauseDoctor_Plural": "SundOvergang doctors"
}